
<p *ngFor="let item of env | keyvalue">
    <b> {{item.key}}:</b><br/>{{item.value}}
</p>